// src/components/CreateModel.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './CreateModel.css';

const models = [
  {
    category: "Text LLM",
    options: [
      { name: "GPT-4o", explanation: "High performance text LLM.", disabled: false },
      { name: "GPT-o1", explanation: "Future update model.", disabled: true },
      { name: "GPT-o3-mini", explanation: "Future update model.", disabled: true },
      { name: "Llama-3-8B", explanation: "Future update model.", disabled: true },
      { name: "LLaMA 2", explanation: "Future update model.", disabled: true },
      { name: "Falcon-7B", explanation: "Future update model.", disabled: true },
      { name: "deepseek-llm-7b-base", explanation: "Future update model.", disabled: true },
      { name: "DeepSeek-V2", explanation: "Future update model.", disabled: true },
      { name: "Qwen1.5-7B", explanation: "Future update model.", disabled: true },
      { name: "Phi-4", explanation: "Future update model.", disabled: true }
    ]
  },
  {
    category: "Text to Image",
    options: [
      { name: "DALLE 3", explanation: "Generate images from text.", disabled: true },
      { name: "stable-diffusion-3.5-large", explanation: "Generate images from text.", disabled: true },
      { name: "stable-diffusion-v1-5", explanation: "Generate images from text.", disabled: true },
      { name: "FLUX.1-dev", explanation: "Generate images from text.", disabled: true },
      { name: "openjourney", explanation: "Generate images from text.", disabled: true }
    ]
  },
  {
    category: "Image to Video",
    options: [
      { name: "stable-video-diffusion-img2vid-xt", explanation: "Generate videos from images.", disabled: true },
      { name: "Ruyi-Mini-7B", explanation: "Generate videos from images.", disabled: true }
    ]
  }
];

function CreateModel() {
  const [selectedModel, setSelectedModel] = useState("");
  const navigate = useNavigate();

  const handleNext = () => {
    // Pass the selected model to the configuration screen
    navigate('/configure', { state: { selectedModel } });
  };

  return (
    <div className="create-model">
      <h2>Select a Model</h2>
      {models.map((group, groupIndex) => (
        <div key={groupIndex} className="model-group">
          <h3>{group.category}</h3>
          {group.options.map((option, index) => (
            <label key={index} className={`model-option ${option.disabled ? "disabled" : ""}`}>
              <input 
                type="radio" 
                name="model" 
                value={option.name} 
                disabled={option.disabled}
                checked={selectedModel === option.name}
                onChange={(e) => setSelectedModel(e.target.value)}
              />
              <span className="model-name">{option.name}</span> - 
              <span className="model-explanation">{option.explanation}</span>
            </label>
          ))}
        </div>
      ))}
      <button className="next-button" onClick={handleNext} disabled={!selectedModel}>
        Next
      </button>
    </div>
  );
}

export default CreateModel;
